import { render, staticRenderFns } from "./PaletteDesigner.vue?vue&type=template&id=329fc3ac"
import script from "./PaletteDesigner.vue?vue&type=script&lang=js"
export * from "./PaletteDesigner.vue?vue&type=script&lang=js"
import style0 from "./PaletteDesigner.vue?vue&type=style&index=0&id=329fc3ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports